import { useQuery } from "@tanstack/react-query";
import { requireSupabaseClient, supabaseClient } from "../../lib/supabase";
import type { ExecutiveDashboardSnapshot } from "../../types/domain";

export type ExecutivePeriod = 7 | 30 | 90 | 365;

export const executiveDashboardKey = (days: ExecutivePeriod) =>
  ["executive-dashboard", days] as const;

export async function getExecutiveDashboard(
  days: ExecutivePeriod,
): Promise<ExecutiveDashboardSnapshot> {
  const { data, error } = await requireSupabaseClient().rpc("get_executive_dashboard", {
    p_days: days,
  });
  if (error) throw new Error("No se pudieron actualizar los indicadores municipales.");
  if (!data || typeof data !== "object") {
    throw new Error("Los indicadores municipales no están disponibles.");
  }
  return data as ExecutiveDashboardSnapshot;
}

export function useExecutiveDashboard(days: ExecutivePeriod) {
  return useQuery({
    queryKey: executiveDashboardKey(days),
    queryFn: () => getExecutiveDashboard(days),
    refetchInterval: 5 * 60 * 1000,
    staleTime: 60 * 1000,
  });
}

function visitorKey(): string | null {
  if (typeof window === "undefined") return null;
  const storageKey = "munipiri-visitor-key";
  const current = window.sessionStorage.getItem(storageKey);
  if (current) return current;
  const created = crypto.randomUUID();
  window.sessionStorage.setItem(storageKey, created);
  return created;
}

export async function recordPublicPageView(path: string): Promise<void> {
  if (!supabaseClient) return;
  const visitor = visitorKey();
  if (!visitor) return;
  await supabaseClient.rpc("record_portal_event", {
    p_municipality_code: "PBY",
    p_page_path: path,
    p_visitor_key: visitor,
  });
}
